const BASE_URL = "https://api.notion.com";
const NOTION_VERSION = "2022-06-28";
const API_VERSION = "v1";
import { axiosDelete, axiosGet, axiosPost } from "./axiosService";
import environment from "@/constants/Environment";
const environmentData = environment();

export function loginNotion(freshLogin: boolean = false): Window | null {
  const prevUrl = String(window.location.pathname);
  const clientId = String(environmentData.NOTION_CLIENT_ID);

  const query = new URLSearchParams({
    client_id: clientId,
    response_type: "code",
    owner: "user",
    redirect_uri: window.location.origin + "/authorize/notion",
    state: `{"prevUrl": "${prevUrl}"}`,
  });

  if (freshLogin) query.append("prompt", "consent");

  const width = 600;
  const height = 700;
  const left =
    (window.screenX || window.screenLeft) + window.outerWidth / 2 - width / 2;
  const top =
    (window.screenY || window.screenTop) +
    window.outerHeight / 2 -
    height / 2 -
    15;

  const authWindow = window.open(
    `${BASE_URL}/${API_VERSION}/oauth/authorize?${query}`,
    "_blank",
    `width=${width},height=${height},left=${left},top=${top}`,
  );

  return authWindow;
}

export async function getNotionConfigs() {
  const response = await axiosGet("/integration/notion/getAppConfig");
  return response?.data;
}

export async function getNotionPages(authId: string) {
  const response = await axiosGet(
    `/integration/notion/getPages?authId=${authId}`,
  );
  return response?.data?.data;
}

export async function setNotionConfig(code: string) {
  await axiosPost(`/integration/notion/setAppConfig`, { code });
}

export async function logoutNotion(authId: string) {
  await axiosDelete(`/integration/notion/deleteAppConfig?authId=${authId}`);
}

export async function extractNotionPages(authId: string, selectedPages: any[]) {
  const response = await axiosPost(
    `/integration/notion/extractPages?authId=${authId}`,
    selectedPages,
  );
  return response?.data;
}
